import { PaginationRequestType } from '@/entity/common/pagination.types';
import { ResponseDataType } from '@/form/form.types';
import { IStoreReady } from '@/store/lib/storeSupport';
import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import { prepareFormData } from '@/store/utils/formDataHelper';
import store from '@/store';
import { IUsers, IUsersItems, UserAddRequestType } from '@/entity/Settings/Users.types';

@Module({
    namespaced: true,
    name: 'settingsUser',
    store,
    dynamic: true,
})
class SettingsUserModule extends VuexModule implements IStoreReady {
    users: IUsers | null = null;
    usersItems: IUsersItems | null = null;
    Loaded = false;
    ready = false;

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ users: IUsers; Loaded: boolean }> {
        const users = await store.$repository.settingsUser.fetchAll(prepareFormData(data));
        let Loaded = false;
        if (users) {
            Loaded = true;
        }
        return { users, Loaded };
    }
    @MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ usersItems: IUsersItems; Loaded: boolean }> {
        let Loaded = false;
        const usersItems = await store.$repository.settingsUser.fetchData(data);
        if (usersItems) {
            Loaded = true;
        }
        return { usersItems, Loaded };
    }
    @Action({ rawError: true })
    async create(data: UserAddRequestType): Promise<ResponseDataType> {
        const response = await store.$repository.settingsUser.create(data);
        console.log('user create response');
        return response;
    }
    @Action({ rawError: true })
    async update(data: UserAddRequestType): Promise<ResponseDataType> {
        return await store.$repository.settingsUser.update(data);
    }

    @Action({ rawError: true })
    async delete(data: {id: number | null}): Promise<ResponseDataType> {
        return await store.$repository.settingsUser.delete(data)
    }

    @Mutation
    setReady(st: boolean) {
        this.ready = st;
    }
}
export const SettingsUsersStore = getModule(SettingsUserModule);
